import { PopoverContent, Skeleton } from '@chakra-ui/react';

import { useAutocompleteContext } from './AutocompleteContext';

export function AutocompleteList({ children }: React.PropsWithChildren) {
  const { isLoading, emptyResult, isOpen, listRef } = useAutocompleteContext();

  return isOpen && !emptyResult ? (
    <PopoverContent
      aria-label="autocomplete-list"
      ref={listRef}
      w="inherit"
      border="none"
      shadow="base"
      px={4}
      py={3}
    >
      {isLoading ? <Skeleton h="8" /> : children}
    </PopoverContent>
  ) : null;
}
